import { swaggerAxiosInstance } from "@vega-api/configs/customInstance";
import type { GetLpTasksResponse } from "@vega-api/generated/types/getLpTasksResponse";

export const PENDING_TASKS_URL = "/api/gp-configuration/v1/tasks";
export const TX_ID_HEADER = "TX-ID";

export type FetchPendingTasksResult =
  | { status: 200; data: GetLpTasksResponse }
  | { status: 202 };

export const fetchPendingTasks = async (
  txId: string,
  signal?: AbortSignal,
): Promise<FetchPendingTasksResult> => {
  const response = await swaggerAxiosInstance.get<GetLpTasksResponse>(
    PENDING_TASKS_URL,
    {
      signal,
      headers: { [TX_ID_HEADER]: txId },
      validateStatus: (status) => status === 200 || status === 202,
    },
  );

  if (response.status === 202) {
    return { status: 202 };
  }

  return { status: 200, data: response.data };
};
